import React, { useEffect, useState, useRef, useContext } from "react";
import { modalEventListener } from "../../utils/ModalEventListener";
import { ToastContainer, toast } from "react-toastify";
import { axios_instance } from "../../api/axios_instance";
import { DetailPageLoadingModalContext } from "../../ContextAPI/context";
import ModalWrapper from "../../layouts/ModalWrapper";

const HoldCaseModal = ({
  closeHoldCaseModal,
  holdCaseReasonsArr,
  caseDetails,
  user,
  changeHoldStatus,
  showHoldCaseModal,
}) => {
  const [holdCaseReasons, setHoldCaseReasons] = useState([]);
  const [reasonCount, setReasonCount] = useState(0);

  const ref = useRef();
  const dropdownContainer = useRef(null);

  const initialState = {
    hold_case_remark: "",
    showNoReasonSelected: false,
    showNoRemarkEntered: false,
  };
  const [state, setState] = useState(initialState);
  const { setShowLoadingModal } = useContext(DetailPageLoadingModalContext);

  useEffect(() => {
    setHoldCaseReasons(holdCaseReasonsArr);
    setReasonCount(0);
    const cleanup = modalEventListener(ref, closeHoldCaseModal);
    document.addEventListener("click", handleDocumentClick);

    return () => {
      cleanup();
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [closeHoldCaseModal, holdCaseReasonsArr]);

  const handleDocumentClick = (e) => {
    // Check if the click was outside the dropdown container
    if (
      !(
        dropdownContainer.current &&
        dropdownContainer.current.contains(e.target)
      )
    ) {
      const ul = dropdownContainer.current;
      if (ul && ul.classList.contains("visible")) {
        ul.classList.remove("visible");
        ul.style.display = "none";
      }
    }
  };

  const toggleDropDown = (container, e) => {
    const ul = container.current;
    if (ul.classList.contains("visible")) {
      ul.classList.remove("visible");
      ul.style.display = "none";
    } else {
      ul.classList.add("visible");
      ul.style.display = "block";
    }
    e.stopPropagation();
  };

  const handleHoldCaseReasonChange = (e) => {
    const { value, checked } = e.target;

    let tempHoldCaseReasons = holdCaseReasons.map((reason) =>
      reason.reason === value ? { ...reason, isChecked: checked } : reason
    );
    setHoldCaseReasons(tempHoldCaseReasons);

    const checkedCount = tempHoldCaseReasons.filter(
      (reason) => reason.isChecked
    ).length;

    setReasonCount(checkedCount);
  };

  const holdCase = async () => {
    const hold_reasons = [];
    for (let reason of holdCaseReasons) {
      if (reason.isChecked) hold_reasons.push(parseInt(reason.id));
    }

    const hold_remark_tag = state.hold_case_remark;
    if (hold_reasons.length === 0) {
      setState({ ...state, showNoReasonSelected: true });
      return;
    }

    if (hold_reasons.includes(10) && hold_remark_tag === "") {
      setState({
        ...state,
        showNoReasonSelected: false,
        showNoRemarkEntered: true,
      });
      return;
    }

    setState({
      ...state,
      showNoReasonSelected: false,
      showNoRemarkEntered: false,
    });

    setShowLoadingModal(true);

    try {
      const result = await axios_instance({
        url: "/dts/holdCase",
        method: "POST",
        data: {
          ref_id: caseDetails.lead_id,
          disbursement_id: caseDetails.id,
          maker_id: user.id,
          user_name: user.name,
          reason: hold_reasons,
          remark: state.hold_case_remark,
          source: 2,
          tranche_no: caseDetails.dts_pay_count,
          sub_stage: caseDetails.sub_stage,
        },
      });
      if (result.status === 200) {
        toast(
          <>
            <span className="glyphicon glyphicon-ok-sign"></span>
            Case has been put on hold successfully
          </>
        );
        changeHoldStatus(2);
        setReasonCount(0);
      } else {
        toast.dismiss();
        return toast.error("Something went wrong.", {
          theme: "colored",
        });
      }
    } catch (error) {
      toast.dismiss();
      return toast.error(
        error?.response?.data?.message
          ? error.response.data.message
          : "Some error occurred while putting the case on hold",
        {
          theme: "colored",
        }
      );
    } finally {
      setShowLoadingModal(false);
    }
  };

  return (
    <ModalWrapper onClose={closeHoldCaseModal} show={showHoldCaseModal}>
      <div className="modal-wrapper">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="holdcase-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closeHoldCaseModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">Hold Case</h4>
          </div>
          <div className="modal-body">
            <label className="hold_case_reason">Select Reason for hold</label>
            {state.showNoReasonSelected ? (
              <div className="hold-case-error errorTxt no-reason">
                Please select hold reason.
              </div>
            ) : (
              ""
            )}

            <div className="form-group ms-drpdwn">
              <div className="btn-group">
                <button
                  type="button"
                  className="multiselect dropdown-toggle btn btn-default"
                  data-toggle="dropdown"
                  title="Status"
                  aria-expanded="false"
                  onClick={(e) => toggleDropDown(dropdownContainer, e)}
                >
                  <span className="multiselect-selected-text">
                    {reasonCount ? `${reasonCount} selected` : `Select Reason`}
                  </span>
                  <b className="caret"></b>
                </button>
                <ul
                  className="multiselect-container dropdown-menu"
                  ref={dropdownContainer}
                >
                  {holdCaseReasons.map((reason, index) => {
                    return (
                      <li className="multiselect-item-indiv" key={index}>
                        <a href="/#" tabIndex="0" id="multiselect-item-anchor">
                          <label className="checkbox dropdown-label">
                            <input
                              type="checkbox"
                              value={reason.reason}
                              checked={reason.isChecked || false}
                              onChange={(e) => handleHoldCaseReasonChange(e)}
                            />
                            {reason.reason}
                          </label>
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="form-group">
              <label>If Other , Please provide Reason</label>
              <textarea
                name="hold_case_remark"
                id="hold_case_remark"
                className="form-control"
                maxLength="450"
                onChange={(e) =>
                  setState({ ...state, hold_case_remark: e.target.value })
                }
              ></textarea>
              {state.showNoRemarkEntered ? (
                <div className="hold-case-error errorTxt no-remark">
                  Please enter any other reason.
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn rc-btn_rset pad-L20 pad-R20"
              data-dismiss="modal"
              onClick={closeHoldCaseModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary hold-case-btn"
              onClick={() => holdCase()}
            >
              Hold Case
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default HoldCaseModal;
